/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-12-02 14:08:22
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-12-02 14:11:09
 */
/*
 * 判断是否为当前页最后一条数据
 * 更新页数
 */
export function updatePageNum(deleteRows, pagination) {
  const deleteAfterTotal = pagination.total - deleteRows.length;
  const num = deleteAfterTotal % pagination.pageSize;
  if (pagination.pageNum > 1 && num === 0) {
    pagination.pageNum--;
  }
  return pagination;
}
